document.addEventListener('DOMContentLoaded', function () {
  const discountCodeForm = document.querySelector('#cart-discount-form');
  const discountCodeInput = document.querySelector('#discount-code-input');
  const discountCodeSuccess = document.querySelector('#discount-code-success');
  const discountCodeError = document.querySelector('#discount-code-error');
  const discountApplied = document.querySelectorAll('.discount-applied button');

  discountApplied.forEach(function(discount){
    discount.onclick = async (e) => {
      // New helper for applying discounts via update.js
      const removeDiscount = async () => {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: "" })
        });
      
        if (!response.ok) {
          throw new Error(`Discount application failed: ${response.status} ${response.statusText}`);
        }
        return response;
      };

      try {
        await removeDiscount();

        // Check if the discount was actually applied instead just assuming it
        // succeeded.
        const cartResponse = await fetchOrShowError('Cart fetch', 'cart.js');
        const cart = await cartResponse.json();

        location.reload();
      } catch(e) {
        showError(e);
      }
    }  
  });

  // / Hide both success and error messages initially
  const hideMessages = () => {
    discountCodeSuccess.style.display = "none";
    discountCodeError.style.display = "none";
  };

  // Function to display error messages
  const showError = (msg) => {
    discountCodeError.textContent = msg;
    discountCodeError.style.removeProperty('display');
  };

  // Function to display success messages
  const showSuccess = (msg) => {
    discountCodeSuccess.textContent = msg;
    discountCodeSuccess.style.removeProperty('display');
  };

  // Request data from the server. Throw a labeled error if it fails.
  const fetchOrShowError = async (label, url) => {
    const localeAwareUrl = window.Shopify.routes.root + url;
    const response = await fetch(localeAwareUrl);
    if (!response.ok) {
      throw new Error(`${label} failed: ${response.status} ${response.statusText}`);
    }
    return response;
  };

  // New helper for applying discounts via update.js
  const applyDiscount = async (code) => {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
  
    if (!response.ok) {
      throw new Error(`Discount application failed: ${response.status} ${response.statusText}`);
    }
    return response;
  };

  // Check the cart to see if a specific discount code has been applied.
  const checkForDiscount = (cart, code) => {
    // Check for order-level discounts

    if (cart.discount_codes && cart.discount_codes.some((discount) => discount.code === code && discount.applicable === true)) {
      return true;
    }

    // Check for line item discounts
    if (cart.items.some((item) => item.discounts?.some((discount) => discount.title === code))) {
      return true;
    }

    return false;
  };

  // Intercept the form being submitted and apply the discount code.
  if( ! discountCodeForm) return;
  discountCodeForm.onsubmit = async (e) => {
    e.preventDefault();
    hideMessages();

    // Field must not be empty
    const code = discountCodeInput.value.trim();
    if (!code) {
      showError('Enter a discount code');
      return;
    }

    try {
      await applyDiscount(code);

      // Check if the discount was actually applied instead just assuming it
      // succeeded.
      const cartResponse = await fetchOrShowError('Cart fetch', 'cart.js');
      const cart = await cartResponse.json();

      if (checkForDiscount(cart, code)) {
        showSuccess(discountCodeForm.getAttribute('data-success'));
        discountCodeForm.reset();

        location.reload();
      } else {
        showError(discountCodeForm.getAttribute('data-error'));
      }
    } catch(e) {
      showError(e);
    }
  };
});


// PageFly
document.addEventListener('DOMContentLoaded', function () {
  // Save the original fetch function
  const originalFetch = window.fetch;

  // Create a wrapper around fetch
  window.fetch = async function(input, init = {}) {

    var response = null;
    var cartDrawer = null;

    // Example: If fetching cart.js, you could add custom logic
    if (typeof input === 'string' && input.includes('/cart/add') && init?.body instanceof FormData) {
      console.log('Fetching the cart...', input, init);
      if(init?.body.get('section-id').includes('__pf-')) {
        cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        if (cartDrawer && typeof cartDrawer.open === 'function') {
          init.body.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
          init.body.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement(document.activeElement);
        }
      }
    }

    // Call the original fetch function and return its result
    if( ! response) response = await originalFetch(input, init);

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartResponse = response.clone();
      cartResponse.json().then((cartResponse) => {
        cartDrawer.renderContents(cartResponse);
        cartDrawer.open();
      });
    }

    return response;
  };
});